import { createSelector } from 'reselect';

import { emptyObject } from 'Lib/constants/placeholder';
import { createKeySelector } from 'Lib/reduxUtils';

export const selectInsendio = createKeySelector('insendio');

/**
 * Get all Insendio merchandising cards
 */
export const getInsendioMerchandisingCards = createSelector(
  selectInsendio,
  (insendio) => insendio.cards
);

/**
 * Get Insendio merchandising card
 */
export const getInsendioMerchandisingCard = createSelector(
  getInsendioMerchandisingCards,
  // only single merchandising card is currently supported, get card based on priority in the future
  (cards) => cards?.[0] ?? emptyObject
);

/**
 * Get all Insendio modal
 */
export const getInsendioModals = createSelector(selectInsendio, (insendio) => insendio.modals);

/**
 * Get Insendio modal
 */
export const getInsendioModal = createSelector(
  getInsendioModals,
  // only a single modal is supported
  (modals) => modals?.[0] ?? emptyObject
);

/**
 * Get product expiry time corresponding to modal
 */
export const getInsendioProductExpiresAt = createSelector(
  selectInsendio,
  (insendio) => insendio.expiresAt
);
